import * as React from "react";
import { Col, Form, Input, Row } from "antd";
import { createRequest, updateRequest } from "@actions/job";
import { Job } from "@models/job";
import withFormWrapper from "../../hocs/withFormWrapper";
import { FormattedMessage } from "react-intl";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  job?: Job;
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
}

type JobFormAllProps = PropsFromState & PropsFromDispatch;

type JobFormStateShape = {
  visible: boolean;
  id: string;
  title: string;
};

class JobForm extends React.Component<JobFormAllProps, JobFormStateShape> {
  constructor(props) {
    super(props);
    const { job } = props;
    this.state = {
      ...this.getStateFromProps(job)
    };
  }

  getStateFromProps = (job: Job | null): object => {
    const obj = job || {};
    return {
      visible: false,
      title: obj.title || "",
      id: obj.id || ""
    };
  };

  getValues = () => {
    let returnValues = null;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
        };
      }
    });

    return {
      payload: returnValues,
      id: this.props.job ? this.props.job.id : null,
    };
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form>
        <Row>
          <Col span={24}>
            <Form.Item
              label={
                <FormattedMessage id="app.title" defaultMessage={`Title`} />
              }
            >
              {getFieldDecorator("title", {
                initialValue: this.state.title,
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.title_is_required"
                        defaultMessage={`Title is required`}
                      />
                    )
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default withFormWrapper(Form.create({ name: "job-form" })(JobForm));
